import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/SM1_LoginScreen.png'


const _withScopeId = n => (_pushScopeId("data-v-5c248586"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing min-h-screen" }
const _hoisted_2 = { class: "art hidden md:fixed md:right-0 md:min-h-screen md:w-1/2 md:px-14 md:flex md:flex-col md:justify-center lg:px-20 py-8" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  width: "900",
  height: "900",
  alt: "Snap! Mobile",
  class: "block w-auto mb-4 px-6 lg:pl-12 lg:pr-10"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-900 md:text-3xl lg:text-3xl font-bold mb-4" }, " The essential software platform for athletics and activities. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-light mb-4" }, " Snap! Mobile One is everything you need to manage and grow your program, all in one app. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("snap-link", {
    href: "https://snapraise.com/snap-mobile",
    size: "xs",
    target: "_blank"
  }, "Learn more about our platform. ")
], -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "content bg-white p-4 min-h-screen md:flex md:flex-row md:w-1/2 md:relative md:rounded-none md:mt-0 lg:p-10 flex-1" }
const _hoisted_10 = { class: "max-w-lg lg:w-3/4 mx-auto self-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("snap-logo", {
  product: "snap-logo-mobile",
  variant: "1line",
  class: "block md:hidden w-52 mb-6"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("snap-logo", {
  product: "snap-logo-mobile",
  variant: "stacked",
  class: "hidden md:block w-44 mb-6"
}, null, -1))
const _hoisted_13 = {
  class: "fixed top-0 right-0 p-1 text-transparent z-50",
  style: {"font-size":"0.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ZendeskHelpWidget = _resolveComponent("ZendeskHelpWidget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        (_ctx.featureOn?.('USER-916-new-image-on-external-pages'))
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.featureOn?.('USER-916-new-image-on-external-pages'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.version), 1),
    _createVNode(_component_ZendeskHelpWidget)
  ], 64))
}